import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export type UploadMarketShopInventoryRequest = {
  buildingId: number
  file: File
}

export type UploadMarketShopInventoryResponse = {
  inserted: number
  skipped: number
}

export const uploadMarketShopInventory = async (data: UploadMarketShopInventoryRequest) => {
  const formData = new FormData()
  formData.append('buildingId', data.buildingId.toString())
  formData.append('csv', data.file)

  const response = await authAPI.post<UploadMarketShopInventoryResponse>(
    '/market-shop/products',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}

export const useUploadMarketShopInventory = () => {
  return useMutation({
    mutationFn: uploadMarketShopInventory,
  })
}
